:host {
  font-size: inherit;
  line-height: inherit;
  font-weight: inherit;
  font-family: inherit;
  color: inherit;
  font-size: var(--body-size-xxlarge);
}

.timer {
  display: flex;
  color: var(--main-titles-inputs-600);

  #hours,
  #mins {
    margin-left: 3px;
  }
}

.calendar-style {
  padding: 2px;
  width: 125px;
  min-height: 139px;
  max-height: 200px;
  height: auto;
  background: var(--chart-305-icon-buttons);

  gz-text {
    text-align: center;
    color: var(--black-layout-700-primary);

    &.title {
      max-width: 80px;
      color: var(--white-layout-300-primary);
    }
  }
}

.calendar-container {
  background: var(--white-layout-303-level-2-elevation);
  width: 60px;
  height: 60px;
  justify-content: center;
  align-self: center;
  border-radius: 4px;
}

.stand-by-text {
  width: 97px;
  height: 27px;
  padding: 1px 4px 1px 4px;
  margin-top: 6px;
  background-color: transparent;
  box-sizing: border-box;
  font-family: "IBMPlexSans", "IBM Plex Sans", sans-serif;
  color: var(--body-text-arrows-400);
  text-align: center;
  line-height: 12px;
  font-size: 10px;
}
